import React, { createContext, useReducer, ReactNode, useEffect } from 'react';
import { UsuarioDTO } from 'utils/models/types';

export interface AuthState {
  usuario: UsuarioDTO | null;
  token: string | null;
}

export interface AuthContextType {
  state: AuthState;
  dispatch: React.Dispatch<AuthAction>;
}

export type AuthAction =
  | { type: 'LOGIN_SUCCESS'; payload: { usuario: UsuarioDTO; token: string } }
  | { type: 'LOGOUT' };

const initialState: AuthState = {
  usuario: null,
  token: null,
};

export const AuthContext = createContext<AuthContextType>({
  state: initialState,
  dispatch: () => null,
});

const authReducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        usuario: action.payload.usuario,
        token: action.payload.token,
      };
    case 'LOGOUT':
      return {
        ...state,
        usuario: null,
        token: null,
      };
    default:
      return state;
  }
};

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedUsu = localStorage.getItem('usuario');

    if (savedToken && savedUsu) {
      dispatch({
        type: 'LOGIN_SUCCESS',
        payload: {
          usuario: JSON.parse(savedUsu),
          token: savedToken,
        },
      });
    }
  }, []);

  return <AuthContext.Provider value={{ state, dispatch }}>{children}</AuthContext.Provider>;
};
